import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Components
import Image from '@/components/common/Image'
import Icon from '@/assets/icons'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

type PropsType = {
  className?: string
}

function HostNotHere(props: PropsType) {
  const { className } = props
  const { t } = useTranslation()

  return (
    <div className={cx('not-here', className)}>
      <div className={cx('not-here-background')}>
        <Image src='/images/playerCameraOffBackground@3x.png' fill alt='player camera off background' />
      </div>

      <div className={cx('not-here-coffee')}>
        <Icon.Coffee />
      </div>

      <p className={cx('not-here-text')}>{t('LiveRoom_Host_Not_Here')}</p>
    </div>
  )
}

export default HostNotHere
